// import { collection, getDocs } from "firebase/firestore";
// import React, { useContext, useEffect, useState } from "react";
// import { db } from "../../FirebaseConfig";
// import { useGlobalData } from "../../Utils/GlobalStoreSingleton";
// import FinanceDataContext from "../../FinanceDataContext"

  // const { componentsData, loading } = useContext(FinanceDataContext);

  // if (loading) return <p>Loading...</p>;

  // const headerData = componentsData.header;

  import { CONSTANTS_STRINGS } from "../../Utils/Constant";
  import CallIcon from "@mui/icons-material/Call";
  import EmailIcon from "@mui/icons-material/Email";
  import InstagramIcon from "@mui/icons-material/Instagram";
  import LinkedInIcon from "@mui/icons-material/LinkedIn";
  import LocationOnIcon from "@mui/icons-material/LocationOn";
  import XIcon from "@mui/icons-material/X";

  function Header() {
    return (
      <header className="w-full h-12 text-white flex justify-between items-center z-30 bg-[#333752] text-sm relative">
        <div className="md:flex justify-between items-center gap-5 pl-10 w-full">
          <div className="md:flex gap-3 flex items-center">
            <div className="flex items-center gap-1">
              <LocationOnIcon fontSize="small" />
              {CONSTANTS_STRINGS?.header?.address || "No address available"}
            </div>
            <div className="flex justify-center items-center gap-2">
              <EmailIcon fontSize="small" />
              <div>
                {CONSTANTS_STRINGS?.header?.email || "No email available"}
              </div>
            </div>
          </div>

          <div className="flex items-center">
            <div className="pl-10 gap-2 flex items-center">
              <CallIcon fontSize="small" />
              {CONSTANTS_STRINGS?.header?.phone || "No phone number"}
            </div>
            <div className="flex px-10 gap-5 items-center">
              <a
                href={CONSTANTS_STRINGS?.header?.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-black"
              >
                <XIcon fontSize="small" />
              </a>
              <a
                href={CONSTANTS_STRINGS?.header?.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-pink-500"
              >
                <InstagramIcon fontSize="small" />
              </a>
              <a
                href={CONSTANTS_STRINGS?.header?.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-blue-600"
              >
                <LinkedInIcon fontSize="small" />
              </a>
            </div>
          </div>
        </div>
      </header>
    );
  }

  export default Header;
  













 // const [state, setState] = useGlobalData("global");
  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const fetchGlobalData = async () => {
  //     try {
  //       const snapshot = await getDocs(collection(db, "finance_collection"));
  //       const docs = snapshot.docs.map((doc) => doc.data());
  //       const headerDoc = docs.find((doc) => doc.component_name === "header");

  //       if (headerDoc) {
  //         setState(headerDoc);
  //       }

  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching header data:", error);
  //       setLoading(false);
  //     }
  //   };

  //   fetchGlobalData();
  // }, [setState]);

  // if (loading) {
  //   return <div className="text-white bg-[#333752] p-2">Loading...</div>;
  // }